<ng-container *translateBlock="let t">
  <div class="step-content">
    @if (!selectSelectType) {
      <app-input-item-selection [formData]="typeConfig"
                                (selectedOption)="onTypeSelect($event)" />
    } @else {
      @if (selectSelectType === 'select') {
        <app-dashboard-box [title]="t('common.title.device-search')"
                           class="transparent device-filter"
                           [buttonLabel]="t('common.actions.reset-filter')"
                           [buttonIconName]="'refresh'"
                           (buttonClick)="resetFilter()"
                           icon="filter_alt">
          {{ deviceCountLabel }}
        </app-dashboard-box>

        <app-dashboard-box [buttonLabel]="deviceCountLabel"
                           [title]="t('common.title.device-list')"
                           icon="list">
          <app-table
            [tableRows]="tableRows"
            [tableConfig]="tableConfigSelect"
            [loading]="loading" />
        </app-dashboard-box>
      } @else {
        <app-dashboard-box [title]="t('common.title.device-filter')"
                           class="transparent device-filter"
                           [buttonLabel]="t('common.actions.reset-filter')"
                           [buttonIconName]="'refresh'"
                           (buttonClick)="resetFilter()"
                           icon="filter_alt">

          <section class="filter-section">
            <app-input-text [formData]="searchConfig" />
            <app-input-select [formData]="statusSelect" />
            <app-input-select [formData]="modelSelect" />
          </section>
        </app-dashboard-box>

        <app-dashboard-box [buttonLabel]="deviceCountLabel"
                           [title]="t('common.title.device-list')"
                           icon="list">
          <app-table [tableConfig]="tableConfigFilter"
                     [tableRows]="tableRows"
                     [loading]="loading" />
        </app-dashboard-box>
      }
    }
  </div>
</ng-container>
